import React from "react";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useNavigate } from "react-router-dom";

const ContinueLearningCard = ({ onStartLearning, data }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`card-styled-wrapper continue-learning-card ${data?.length > 0 ? "has-data" : ""}`}
    >
      {data && data.length > 0 ? (
        <>
          <p className="continue-learning-title">Continue Learning</p>
          <div className="continue-learning-list custom-scrollbar">
            {data.map((item, index) => (
              <div
                key={`${item.id || item._id || "item"}-${index}`}
                className="continue-learning-item"
                onClick={() => item.path && navigate(item.path)}
              >
                <div className="item-info">
                  <span className="item-name">{item.name}</span>
                  <span className="item-type">{item.page_type}</span>
                </div>
                <ArrowForwardIcon className="item-icon" sx={{ fontSize: 18 }} />
              </div>
            ))}
          </div>
        </>
      ) : (
        <div className="continue-learning-content">
          <p className="continue-learning-text">
            Go to lesson to start learning.
          </p>
          <button
            type="button"
            onClick={onStartLearning}
            className="start-learning-button"
          >
            Start Learning <ArrowForwardIcon sx={{ fontSize: 20 }} />
          </button>
        </div>
      )}
    </div>
  );
};

export default ContinueLearningCard;
